export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'defaultImageUrl',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 70,
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'goodsName',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    minWidth: 300,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'amzSkuNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    slots: { default: 'displayNo' },
  },
  {
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    align: 'center',
    minWidth: 100,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_qty') || '产品数量',
    field: 'qty',
    align: 'center',
    minWidth: 100,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_ctnQty') || '箱数',
    field: 'ctnQty',
    align: 'center',
    minWidth: 100,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_sampleQty') || '样品数量',
    field: 'sampleQty',
    align: 'center',
    minWidth: 100,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subQty') || '总数量',
    field: 'subQty',
    align: 'center',
    minWidth: 100,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_firstQty') || '首批上架数量',
    field: 'firstQty',
    align: 'center',
    minWidth: 100,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_firstSaleDay') || '首批上架日期',
    field: 'firstSaleDay',
    align: 'center',
    minWidth: 100,
  },
  {
    title: that.$l('table_label_shipmentDate') || '订舱开始日期',
    field: 'shipmentDate',
    align: 'center',
    minWidth: 120,
  },
  {
    title: that.$l('table_label_shipmentEndDate') || '订舱截止日期',
    field: 'shipmentEndDate',
    align: 'center',
    minWidth: 120,
  },
  {
    title: that.$l('table_label_cargoReadyDay') || '工厂货好日期',
    field: 'cargoReadyDay',
    align: 'center',
    minWidth: 120,
  },
  {
    title: that.$l('table_label_operateRemark') || '运营备注',
    field: 'operateRemark',
    align: 'center',
    minWidth: 120,
  },
  {
    title: that.$l('table_label_designRemark') || '企划备注',
    field: 'designRemark',
    align: 'center',
    minWidth: 120,
  },
]
